import { render, staticRenderFns } from "./home_goods_list.vue?vue&type=template&id=24186f8e&scoped=true"
import script from "./home_goods_list.vue?vue&type=script&lang=js"
export * from "./home_goods_list.vue?vue&type=script&lang=js"
import style0 from "./home_goods_list.vue?vue&type=style&index=0&id=24186f8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24186f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24186f8e')) {
      api.createRecord('24186f8e', component.options)
    } else {
      api.reload('24186f8e', component.options)
    }
    module.hot.accept("./home_goods_list.vue?vue&type=template&id=24186f8e&scoped=true", function () {
      api.rerender('24186f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_goods_list.vue"
export default component.exports